import { cn } from '@/utils/cn';

import styles from './status-tag.module.css';

interface StatusTagProps {
  status: string;
  className?: string;
}

const statusMap: Record<string, { label: string; color: string }> = {
  pending: { label: '待批阅', color: 'info' },
  graded: { label: '已初评', color: 'info' },
  reviewed: { label: '已复核', color: 'success' },
  appealed: { label: '有申诉', color: 'warning' },
  needs_revision: { label: '需修改', color: 'danger' },
  confirmed: { label: '已通过', color: 'success' },
  modified: { label: '已修改', color: 'warning' },
  rejected: { label: '已驳回', color: 'danger' },
  draft: { label: '草稿', color: 'aux' },
  published: { label: '已发布', color: 'success' },
  closed: { label: '已截止', color: 'aux' },
};

export function StatusTag({ status, className }: StatusTagProps) {
  const config = statusMap[status] || { label: status, color: 'aux' };
  return (
    <span className={cn(styles.tag, styles[config.color], className)}>
      <span className={styles.dot} />
      {config.label}
    </span>
  );
}
